// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"8fb6bc88","91":"ea6245c2","488":"9fbbbfdc","679":"455aaecd","685":"55416462"}[chunkId] + ".chunk.css";
};